<template>
    <div class="agreement">
      <h3 style="text-align: center;">隐私协议</h3>
        <p>本隐私政策内容适用于i致富平台（“我们”）网站、网站的网页端、移动客户端（包括iOS、安卓及已有或未来将新增的任何其他移动客户端）及其他由我们提供的功能与服务（以下统称“i致富”或“i致富平台”）。</p>
        <p>尊敬的i致富平台用户（“用户”或“您”）：我们对《隐私政策》进行了更新。</p>
        <p>欢迎您访问i致富！i致富提醒您：i致富是由深圳致复科技有限公司运营，总部位于深圳市福田区莲花街道福中社区福中一路1001号生命保险大厦二十层2007室。本隐私政策与您在i致富使用i致富的产品或服务（以下统称为“服务”）息息相关，请您在使用服务前仔细阅读并确认您已经充分理解和同意本隐私政策。
        </p>
        <p>i致富深知个人隐私的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。我们也将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。我们在您使用i致富的过程中所收集到的个人信息将只用于本《隐私政策》中所规定的用途。
        </p>
        <h3>本隐私政策将帮助您了解以下内容：</h3>
        <p>1、如何收集和使用您的个人信息</p>
        <p>2、如何共享、转让、公开披露您的个人信息</p>
        <p>3、如何保存您的个人信息</p>
        <p>4、Cookie的使用</p>
        <p>5、个人敏感信息提示</p>
        <p>6、个人信息安全</p>
        <p>7、个人信息安全事件的处置</p>
        <p>8、未成年人的个人信息保护</p>
        <p>9、您的个人信息权利</p>
        <p>10、本隐私政策的变更</p>
        <p>11、如何联系我们</p>
        <h3>1、如何收集和使用您的个人信息</h3>
        <p>您理解并同意：</p>
        <p>“个人信息”是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
        <p>“个人敏感信息”是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。</p>
        <h3>（一）收集和使用您个人信息的基本功能</h3>
        <p>我们的服务包括一些基本功能，这些功能包括实现网上购买产品和使用工具所必须的功能，改进我们的服务所必须的功能及保障交易安全所必须的功能。我们需要收集、保存和使用下列与您有关的个人信息才能实现该等基本功能。如果您不提供相关信息，您将无法享受我们提供的服务，请您知晓，必要时，我们可能会将您提供的身份信息向发证机关进行核验，以保障人证合一，账户及个人信息安全，各项基本功能及其所需的个人信息类型如下：
        </p>
        <p>（1）注册成为我们的用户并登录</p>
        <p>•如果您注册成为我们的用户，您需要创建用户名和密码，便于我们为您提供购买产品和使用工具等服务，并提供姓名、证件号码、证件有效期、出生日期，以及与身份信息对应的且可通话联络的唯一手机号码、短信息验证码、电子邮箱、旅客类型。
        </p>
        <p>• 如果您需要使用面容ID登录或指纹识别登录，您需要提供您的生物识别信息（人脸信息/指纹信息），但请您知悉，我们仅接收您使用的终端验证的结果，并不收集您的生物识别信息（人脸信息/指纹信息）。</p>
        <p>•如果您仅使用浏览网站、您不需要注册成为我们的用户，也无需提供上述信息。</p>
        <p>（2）为您提供产品信息和工具类的服务</p>
        <p>• 如您选择购买产品服务，需提供个人姓名、证件号码、手机号码。</p>
        <p>（3）保障您的交易安全</p>
        <p>为提高您使用我们及我们合作伙伴提供服务的安全性，确保操作环境安全与识别注册账号异常状态，更好地保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反中华人民共和国法律法规或i致富相关协议规则的情况，我们可能使用或整合您的用户信息、交易信息、设备信息、位置信息、日志信息以及我们合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
        </p>
        <h3>（二）收集和使用您个人信息的扩展功能</h3>
        <p>• 为使您享受的服务更便捷或使您的体验更丰富，我们提供了以下扩展功能，下列功能可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以使用第（一）条所列明的基本功能。这些扩展功能及其所需的个人信息类型如下：
        </p>
        <p>（1）为方便您使用产品或服务</p>
        <p>（a）设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息，可用于识别您的设备（例如设备型号、操作系统版本、设备设置、唯一设备标识符，设备MAC地址，应用安装列表等软硬件特征信息），以向您提供安全保障。请您理解，当您将应用移动切换到设备后台运行时，由于网络异常或系统原因，您此前使用应用而产生的信息收集行为可能无法立即停止，从而导致短暂的后台信息收集行为。
        </p>
        <p>（b）位置信息：指您开启设备定位功能并使用我们基于位置提供的相关服务时，根据您当前您位置的信息,例如IP地址、GPS位置以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息，开启位置权限，方便在定位用户当前所在的城市。
        </p>
        <p>（c）日志信息：当您使用我们的网站或客户端提供的产品或服务时，为向您提供便捷化的服务，我们会自动收集您对我们服务的使用情况，作为有关网络日志保存。用于运营分析，性能安全漏洞的上报。例如您的访问足迹等。</p>
        <p>请您注意，单独的设备信息、日志信息、位置信息是无法识别特定自然人身份的。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息按照本隐私政策对其进行处理与保护。
        </p>
        <p>（2）为您提供您购买或使用的特定的产品或服务</p>
        <p>扩展功能可能需要您在您的设备中向我们开启您设备的访问权限：</p>
        <p>（a）相机/摄像头权限：如您需要使用扫描分享图片的二维码、人脸验证功能，请开启相机使用权限。</p>
        <p>（b）相册/图片库权限：如您需要使用保存、分享列车信息功能，请开启相册权限。</p>
        <p>请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。
        </p>
        <p>（3）其他用途</p>
        <p>我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善i致富的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务，例如使用匿名数据进行机器学习或模型算法训练；为实现特定的广告服务功能，我们将收集客户端粗略的位置信息、设备信息、广告展示与点击数据，用于广告投放、监测归因和数据统计。
        </p>
        <h3>（三）征得授权同意的例外</h3>
        <p>根据中华人民共和国相关法律法规、国家标准，以下情形中收集您的个人信息无需征得您的授权同意：</p>
        <p>1)与我们履行法律法规规定的义务相关的；</p>
        <p>2）与中华人民共和国国家安全、国防安全直接相关的；</p>
        <p>3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>4）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
        <p>5）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
        <p>6）所收集的个人信息是您自行向社会公众公开的；</p>
        <p>7）根据您要求签订和履行合同所必需的；</p>
        <p>8）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
        <p>9）维护所提供产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。</p>
        <p>10）作为学术研究机构，出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。</p>
        <p>2、如何共享、转让、公开披露您的个人信息</p>
        <p>（1）共享</p>
        <p>根据您的选择与授权或符合“共享、转让、公开披露个人信息时事先征得授权同意的例外”中的情形，我们可能会向第三方共享您的订单信息、账户信息、联系方式以及位置信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。
        </p>
        <p>为了您能够接收信息推送、使用第三方平台提供的服务、使用第三方支付、使用地图服务、使用人脸识别功能，我们的应用中会嵌入授权合作伙伴的软件工具开发包(SDK)或类似其他应用程序，我们通过操作系统提供接口调用的方式使用这些SDK，您可以通过点击此处查阅这些第三方SDK的名称、提供方、收集个人信息的目的及类别，在您使用第三方提供的服务前，请您确保已充分了解该第三方的个人信息收集使用规则，如遇到问题请咨询该公司客服。
        </p>
        <p>在某些情形下我们也会受委托处理您的个人信息，我们作为受托方的情形通常包括：</p>
        <p>• 委托我们进行推广的合作伙伴。有时我们会代表其他企业向使用我们产品与/或服务的用户群提供促销推广的服务。在您同意之后，我们会向这些合作伙伴提供有关其推广覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它不会识别您个人。例如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的产品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。
        </p>
        <p>对于我们与之共享个人信息的公司、组织，我们会与其签署严格的保密协定，要求他们按照本隐私政策以及我们其他相关的保密和安全措施来处理个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途，如要改变个人信息的处理目的，将再次征求您的授权同意。如我们与第三方分享儿童的个人信息，我们将进行安全评估并采用加密、匿名化、去标识处理等方法保障儿童的信息安全。
        </p>
        <p>（2）转让</p>
        <p>除符合“共享、转让、公开披露个人信息时事先征得授权同意的例外”中的情形外，我们不会将您的个人信息转让给任何公司、组织和个人。</p>
        <p>在涉及收购、兼并、重组、破产或类似的交易或情形时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，如变更个人信息使用目的的，我们将要求该公司、组织重新向您征求授权同意。若破产而无承接方的，在符合法律规定的情况下，我们会对您的个人信息做删除处理。
        </p>
        <p>（3）公开披露</p>
        <p>我们仅会在以下情形，公开披露您的个人信息：</p>
        <p>• 在您明确同意或主动选择情况下，我们可能会公开披露您所指定的个人信息；</p>
        <p>• 根据中华人民共和国法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。
        </p>
        <p>（4）共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
        <p>根据中华人民共和国相关法律法规、国家标准，以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
        <p>1）与我们履行法律法规规定的义务相关的；</p>
        <p>2）与国家安全、国防安全直接相关的；</p>
        <p>3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>4）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
        <p>5）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人授权同意的；</p>
        <p>6）所涉及的个人信息是您自行向社会公众公开的个人信息；</p>
        <p>7）根据您要求签订和履行合同所必需的；</p>
        <p>8）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
        <p>9）维护我们所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障。</p>
        <p>根据中华人民共和国法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
        </p>
        <p>3、如何保存您的个人信息</p>
        <p>即使您从中国大陆以外地区或国家访问我们网站，请您注意，您的信息将存储于中国大陆，并且在中国大陆进行处理。</p>
        <p>一般而言，我们仅为实现上述目的所必需的最短时间保留您的个人信息。在超出保存期限后，我们会对您的个人信息进行删除或者匿名化处理。如我们停止运营i致富产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并在终止服务或运营后对所持有的个人信息进行删除或匿名化处理。
        </p>
        <p>4、Cookie的使用</p>
        <p>Cookie是网页服务器放在您访问设备上的文本文件，会帮助您在后续访问时调用信息，简化记录您填写个人信息的流程。您有权接受或拒绝Cookie，如果浏览器自动接收Cookie，您可以根据自己的需要修改浏览器的设置以拒绝Cookie。请注意，如果您选择拒绝Cookie，那么您可能无法完全体验i致富提供的服务。
        </p>
        <p>5、个人敏感信息提示</p>
        <p>i致富在此提醒您，您在使用i致富为您提供的产品及服务中所上传或发布的内容和信息可能涉及您的个人敏感信息。包括但不限于证件号码、个人生物识别信息（人脸信息、指纹信息）、行程信息、14
            岁以下（含）儿童的个人信息。因此，您需要在使用我们为您提供的产品或服务前谨慎考虑。您同意这些个人敏感信息将按照本隐私政策阐明的目的和方式来进行处理。</p>
        <p>6、个人信息安全</p>
        <p>（1）i致富非常重视信息安全，成立了专门的负责团队。我们努力为您提供信息保护，采取了合适的管理、技术以及物理安全措施，参照国内外信息安全标准及最佳实践建立了与业务发展相适应的信息安全保障体系。</p>
        <p>（2）我们从数据的生命周期角度出发，在数据收集、存储、显示、处理、使用、销毁等各个环节建立了安全防护措施，根据信息敏感程度的级别采取不同的控制措施，包括但不限于访问控制、SSL（Secure Socket
            Layer）加密传输进行加密存储、敏感信息脱敏显示等。我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，使用加密技术提高个人信息的安全性，使用受信赖的保护机制防止个人信息遭到恶意攻击，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。
        </p>
        <p>（3）我们部署了访问控制机制，尽力确保只有授权人员才可访问个人信息。我们对可能接触到您信息的员工也采取了严格管理，可监控他们的操作情况，对于数据访问、内外部传输使用、脱敏、解密等重要操作建立了审批机制，并与上述员工签署保密协议等。与此同时，我们还定期对员工进行信息安全培训，要求员工在日常工作中形成良好操作习惯，提升数据保护意识。
        </p>
        <p>（4）尽管有前述的安全措施，但同时也请您理解在网络上不存在“完善的安全措施”。我们会按现有的技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄露、损毁或丢失。</p>
        <p>（5）您的账户均有安全保护功能，请妥善保管您的账号及密码信息，切勿将密码告知他人或其他网站，如果您发现自己的个人信息泄露，特别是您的账号和密码发生泄露，请您立即与我们的客服联系，以便我们采取相应的措施。</p>
        <p>（6）请您及时保存或备份您的文字、图片等其他信息，您需理解并接受，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
        <p>7、个人信息安全事件的处置</p>
        <p>在不幸发生个人信息安全事件后，我们会启动应急预案，阻止安全事件扩大，并将按照中华人民共和国法律法规的要求向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。
        </p>
        <p>8、未成年人的个人信息保护></p>
        <p>按照中华人民共和国相关法律规定，未满18周岁为未成年人，不满 14 周岁的未成年人为儿童。</p>
        <p>i致富主要面向成年人，如果没有父母或监护人的同意，未成年人，尤其是未满14周岁儿童不应创建自己的个人信息主体账户。如您是未成年人的监护人，我们提示您正确履行监护职责，保护未成年人个人信息安全。若您所监护的未成年人使用我们的服务的，您应予以正确引导和监护。如您是未成年人，在使用i致富的服务前，请在父母或监护人的陪同和帮助下仔细阅读本隐私政策，并在征得其父母或监护人同意的前提下使用我们的服务或向我们提供信息。
        </p>
        <p>对于经父母或监护人同意使用我们的产品或服务而收集未成年人，尤其是儿童的个人信息情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。如果我们发现自己在未事先获得父母或监护人同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
        </p>
        <p>对于儿童个人信息，我们会进一步采取以下措施：</p>
        <p>（1）对于收集到的儿童个人信息，我们除遵守本隐私政策关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。
        </p>
        <p>（2）当您作为监护人为被监护的儿童选择使用i致富相关服务时，我们可能需要向您收集被监护的儿童个人信息，用于向您履行相关服务之必要。在具体服务中需要向您收集儿童个人信息的，我们会事先取得您的授权同意，并告知您收集的目的和用途。如果您不提供前述信息，您将无法享受我们提供的相关服务。您作为监护人应当正确履行监护职责，保护儿童个人信息安全。若儿童本人需要注册或使用我们的产品与与/或服务，您应正确引导并予以监护。
        </p>
        <p>（3）儿童或其监护人有权随时访问和更正儿童个人信息，还可以向我们提出更正和删除的要求。</p>
        <p>我们指定了专人负责儿童个人信息保护事宜，如您对儿童个人信息相关事宜有任何意见、建议或投诉、举报，请通过本隐私政策中列明的联系方式联系我们。我们会及时为您提供帮助。</p>
        <p>9、您的个人信息权利</p>
        <p>我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息的权利，法律法规另有规定的除外。为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，通常情况下，我们将在收到您反馈并验证您的身份后的15个工作日内受理您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
        </p>
        <p>您可以随时登录“我的i致富”，进入个人中心、常用信息等功能模块以访问、更正、删除您的账户信息，包括个人资料。</p>
        <p>（1）您可以通过关闭设备功能来撤回您的授权。您也可以通过注销账户的方式撤回我们继续收集您个人信息的全部授权。</p>
        <p>（2）在以下情形中，按照法律法规、国家标准的要求，我们将无法响应您的请求：</p>
        <p>1) 与我们履行法律法规规定的义务相关的；</p>
        <p>2) 与国家安全、国防安全直接相关的；</p>
        <p>3) 与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>4) 与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
        <p>5) 有充分证据表明您存在主观恶意或滥用权利的；</p>
        <p>6) 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人授权同意的；</p>
        <p>7) 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
        <p>8) 涉及商业秘密的。</p>
        <p>10、本隐私政策的变更</p>
        <p>本隐私政策的内容可能会不时更新，以适应法律、技术或商业的发展。更新后的隐私政策将在i致富站上公布，重大变更将以网站公告、用户通知等合适的形式告知用户。本隐私政策所指的重大变更包括：</p>
        <p>（1）我们的服务模式发生重大变化，如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
        <p>（2）我们在所有权结构、组织架构等方面发生重大变化，如业务调整、破产并购等引起的所有者变更等；</p>
        <p>（3）个人信息共享、转让或公开披露的主要对象发生变化；</p>
        <p>（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
        <p>（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
        <p>（6）个人信息安全影响评估报告表明存在高风险时。</p>
        <p>当您使用我们的网站时，您可以随时审查我们的隐私政策，以便您了解其修改。您可以在本隐私通知的顶部的“最近更新”的日期处查看本隐私政策的最新更新日期。</p>
        <p>您可以通过以下方式与我们联系，一般情况下，我们将在15个工作日内受理并处理您关于个人信息的请求。</p>
        <p>地址：深圳市福田区莲花街道福中社区福中一路1001号生命保险大厦二十层2007室</p>
        <p>邮箱：service@dtfcloud.com</p>
        <p>如果您对我们的回复不满意，并且认为我们的个人信息处理行为损害了您的合法权益，您可以向i致富客服进行投诉，也可以向公安机关或网信、电信、市场等监管部门进行投诉或举报，或向被告住所地有管辖权的人民法院提起诉讼。</p>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.agreement {
    padding: 15px;
    font-size: 14px;
    text-align: left;
    text-indent: 2em;
    line-height: 2;
    background-color: #fff;
}
 
</style>